// @flow
export const baseUrl = '/settings';
